import React from 'react'

const Close = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="53" height="53" fill="#EEEEEE" />
            <path d="M33.728 19.2734L19.2734 33.728" stroke="#33363F" strokeWidth="2.40909" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.272 19.2734L33.7266 33.728" stroke="#33363F" strokeWidth="2.40909" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default Close